import { CHATBOT_PAGE_CLOSE_WITH_SOCKET } from './constants.js';

export const getRecaptchaToken = async () => {
    try {
        // Get the shadow root and navigate to the parent DOM
        window.showActionFade();
        const { recaptchaEnabled } = JSON.parse(document.querySelector("#app-data").innerHTML);
        let token;
        if (Boolean(recaptchaEnabled)) {
            token = await new Promise((resolve) => {
                grecaptcha.ready(async function () {
                    const _token = await window.grecaptcha.execute(recaptchaEnabled, { action: 'submit' });
                    resolve(_token);
                });
            });
        }

        return token;
    } catch (error) {
        console.error("Error getting recaptcha token:", error);
        return null;
    }
};

// Event listeners specifically for browser/tab close detection only
// Covers actual browser and tab closing events across all browsers
export const setupCloseDetection = (socket, mode, userData, url) => {
    // Function to handle browser/tab close events
    const handlePageClose = async (event) => {
        try {
            const token = await getRecaptchaToken();

            if (token && socket) {
                socket.emit(CHATBOT_PAGE_CLOSE_WITH_SOCKET, {
                    token: token,
                    socketId: socket.id,
                    mode: mode,
                    url: url,
                    userData: userData,
                });
            }
        } catch (error) {
            console.error('Error in close handler:', error);
        }
    };

    // Detect iOS devices (special handling needed)
    const isIOS = /iPhone|iPad|iPod/.test(window.navigator.userAgent);

    // Core events for browser/tab closing
    window.addEventListener('beforeunload', handlePageClose);
    window.addEventListener('unload', handlePageClose);

    // Essential for iOS Safari and mobile browsers
    window.addEventListener('pagehide', handlePageClose);

    // Additional iOS-specific handling for tab/browser close
    if (isIOS) {
        document.addEventListener('visibilitychange', () => {
            if (document.visibilityState === 'hidden') {
                // Small delay to distinguish from tab switching
                setTimeout(() => {
                    if (document.visibilityState === 'hidden') {
                        handlePageClose();
                    }
                }, 1000);
            }
        });
    }
};
